import {Component, Prop, Vue} from "vue-property-decorator";
import {Notification} from "~/modules/notifications/lib/notification";
import {PublicationOptions} from "~/modules/notifications/lib/publication-options";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import {Label} from "~/components/forms/label";
import {XInput} from "~/components/forms/x-input";
import {RichTextEditor} from "~/components/forms/rich-text-editor";
import {Checkbox} from "~/components/checkbox";
import {NotificationMaxContentSize} from "~/modules/notifications/components/notification-max-content-size";
import {DateTimePicker} from "~/components/forms/datetime-picker";

@Component
export class FeedNotificationEditor extends Vue {

  @Prop({type: Object, required: true}) notification: Notification;
  @Prop({type: Object, required: true}) options: PublicationOptions;

  render() {
    return (
      <div>
        <Columns>
          <Column>
            <Label text="Titre *"/>
            <XInput v-model={this.notification.title}/>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Label text="Contenu"/>
            <button class="button m-b-10 is-small"
                    onClick={() => this.$bubble("previewNotification", this.notification)}>Preview
            </button>
            <RichTextEditor v-model={this.notification.content}/>
            <NotificationMaxContentSize notification={this.notification}/>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Label text="Description"/>
            <XInput v-model={this.notification.description}/>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Label text="Date de publication (immédiat si non précisé)"/>
            <DateTimePicker v-model={this.notification.publicationDate}/>
          </Column>
        </Columns>
        <Checkbox v-model={this.options.flash}>
          Générer une notification flash
        </Checkbox>


      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-5b60b61d/feed-notification-editor.tsx" });